<!--地区选择器-->
<template>
  <div class="item-box">
    <!--标题-->
    <div :class="['question-item-title',{isMbottom:question.show_rule.is_check_show}]">
      <span><i v-if="!$store.state.settingData.base.notorder">{{ number }}、</i>
          <span class="q-title" v-html="question.title"></span>
          <Icon type="ios-information-circle" @click="hintShowClick"
                v-if="question.show_rule.is_check_show && question.show_rule.hint.length>0"/>
      </span>
    </div>
    <span class="title-tips" v-html="question.show_rule.hint" v-if="!question.show_rule.is_check_show"></span>
    <div class="q-content" v-if="question.subtype!=='多级下拉'">
      <Select v-model="sheng"
              @on-change="choseProvince"
              placeholder="请选择省"
              size="large">
        <Option v-for="item in province"
                :key="item.id"
                :value="item.id">
          {{ item.value }}
        </Option>
      </Select>
      <Select v-model="shi"
              @on-change="choseCity"
              placeholder="请选择市"
              size="large">
        <Option v-for="item in shi1"
                :key="item.id"
                :value="item.id">
          {{ item.value }}
        </Option>
      </Select>
      <Select v-model="qu"
              v-if="question.subtype !== '省市'"
              @on-change="choseBlock"
              placeholder="请选择区/县"
              size="large">
        <Option v-for="item in qu1"
                :key="item.id"
                :value="item.id">
          {{ item.value }}
        </Option>
      </Select>

      <Input v-if="question.verify_rule.is_edit_addressinfo"
             v-model="detailedAddress"
             @blur="detailedAddressBlur"
             class="address"
             size="large"
             placeholder="详细地址">
      </Input>
    </div>
    <div class="q-content" v-else>
      <div class="selected-box">
        <Select v-model="selectValue1"
                @on-change="selectValue1Change"
                size="large">
          <Option v-for="item in selectArr1"
                  :key="item.value"
                  :value="item.value">
            {{ item.label }}
          </Option>
        </Select>
        <Select v-model="selectValue2"
                @on-change="selectValue2Change"
                size="large">
          <Option v-for="item in selectArr2"
                  :key="item.value"
                  :value="item.value">
            {{ item.label }}
          </Option>
        </Select>
        <Select v-model="selectValue3"
                @on-change="selectValue3Change"
                v-if="question.show_rule.level ==='3'"
                size="large">
          <Option v-for="item in selectArr3"
                  :key="item.value"
                  :value="item.value">
            {{ item.label }}
          </Option>
        </Select>
      </div>
    </div>
    <!--提示弹框-->
    <Modal class="hintModel" v-model="modal" width="70%" :closable="false">
      <p slot="header">
        <Icon type="ios-information-circle"></Icon>
        <span>填写提示</span>
      </p>
      <div style="color: #4e4c56;font-size: 16px">
        <span v-html="question.show_rule.hint"></span>
      </div>
      <div slot="footer">
        <p @click="clearClick">我知道了</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'tCasader',
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    number: {
      type: Number,
      default() {
        return 1;
      }
    },
  },
  data() {
    return {
      mapJson: '',
      province: '',
      sheng: '',
      shi: '',
      qu: '',
      detailedAddress: '',
      shi1: [],
      qu1: [],
      city: '',
      block: '',
      modal: false,
      selectValue1: '',
      selectArr1: [],
      selectValue2: '',
      selectArr2: [],
      selectValue3: '',
      selectArr3: []
    }
  },
  methods: {
    // 加载china地点数据，三级
    getCityData: function () {
      let that = this
      let url = ''
      process.env.NODE_ENV === 'development' ? url = '/static/map.json' : url = '/h5/static/map.json'
      axios.get(url).then(function (response) {
        if (response.status === 200) {
          let data = response.data
          that.province = [] //省
          that.city = []  //市
          that.block = []  //区
          // 省市区数据分类
          for (let item in data) {
            if (item.match(/0000$/)) {//省
              that.province.push({id: item, value: data[item], children: []})
            } else if (item.match(/00$/)) {//市
              that.city.push({id: item, value: data[item], children: []})
            } else {//区
              that.block.push({id: item, value: data[item]})
            }
          }
          // 分类市级
          for (let index in that.province) {
            for (let index1 in that.city) {
              if (that.province[index].id.slice(0, 2) === that.city[index1].id.slice(0, 2)) {
                that.province[index].children.push(that.city[index1])
              }
            }
          }
          // 分类区级
          for (let item1 in that.city) {
            for (let item2 in that.block) {
              if (that.block[item2].id.slice(0, 4) === that.city[item1].id.slice(0, 4)) {
                that.city[item1].children.push(that.block[item2])
              }
            }
          }
        } else {
          console.log(response.status)
        }
      }).catch(function (error) {
        console.log(typeof +error)
      })
    },
    // 选省
    choseProvince: function (e) {
      for (let index2 in this.province) {
        if (e === this.province[index2].id) {
          this.shi1 = this.province[index2].children
          this.shi = this.province[index2].children[0].id
          this.qu1 = this.province[index2].children[0].children
          this.qu = this.province[index2].children[0].children[0].id
          this.E = this.qu1[0].id
          this.$forceUpdate()
        }
      }
      let addressArr = []
      if (this.question.subtype === '省市') {
        addressArr = [this.sheng, this.shi]
      } else {
        addressArr = [this.sheng, this.shi, this.qu]
      }
      let obj = {}
      obj[this.question.id] = addressArr
      this.$store.dispatch('userAnswersActions', obj)
    },
    // 选市
    choseCity: function (e) {
      for (let index3 in this.city) {
        if (e === this.city[index3].id) {
          this.qu1 = this.city[index3].children
          this.qu = this.city[index3].children[0].id
          this.E = this.qu1[0].id
        }
      }
      let addressArr = []
      if (this.question.subtype === '省市') {
        addressArr = [this.sheng, this.shi]
      } else {
        addressArr = [this.sheng, this.shi, this.qu]
      }
      let obj = {}
      obj[this.question.id] = addressArr
      this.$store.dispatch('userAnswersActions', obj)
    },
    // 选区
    choseBlock: function (e) {
      this.E = e;
      let addressArr = []
      if (this.question.subtype === '省市') {
        addressArr = [this.sheng, this.shi]
      } else {
        addressArr = [this.sheng, this.shi, this.qu]
      }
      let obj = {}
      obj[this.question.id] = addressArr
      this.$store.dispatch('userAnswersActions', obj)
    },
    // 详细地址
    detailedAddressBlur() {
      let addressArr = []
      addressArr = [this.sheng, this.shi, this.qu, this.detailedAddress]
      let obj = {}
      obj[this.question.id] = addressArr
      this.$store.dispatch('userAnswersActions', obj)
    },
    hintShowClick() {
      this.modal = true
    },
    clearClick() {
      this.modal = false
    },
    selectValue1Change(val){
      let addressArr = []
      if(this.question.show_rule.level ==='3'){
        addressArr = [this.selectValue1, this.selectValue2, this.selectValue3]
      }else {
        addressArr = [this.selectValue1, this.selectValue2]
      }
      let obj = {}
      obj[this.question.id] = addressArr
      this.$store.dispatch('userAnswersActions', obj)
    },
    selectValue2Change(val){
      let addressArr = []
      if(this.question.show_rule.level ==='3'){
        addressArr = [this.selectValue1, this.selectValue2, this.selectValue3]
      }else {
        addressArr = [this.selectValue1, this.selectValue2]
      }
      let obj = {}
      obj[this.question.id] = addressArr
      this.$store.dispatch('userAnswersActions', obj)
    },
    selectValue3Change(val){
      let addressArr = []
      addressArr = [this.selectValue1, this.selectValue2, this.selectValue3]
      let obj = {}
      obj[this.question.id] = addressArr
      this.$store.dispatch('userAnswersActions', obj)
    }
  },
  mounted() {
    if (this.$store.state.user_answers[this.question.id] !== '') {
      if (this.question.subtype === '省市') {
        this.sheng = this.$store.state.user_answers[this.question.id][0]
        this.shi = this.$store.state.user_answers[this.question.id][1]
      } else {
        this.sheng = this.$store.state.user_answers[this.question.id][0]
        this.shi = this.$store.state.user_answers[this.question.id][1]
        this.qu = this.$store.state.user_answers[this.question.id][2]
        this.detailedAddress = this.$store.state.user_answers[this.question.id][3]
      }
    }
  },
  created: function () {
    this.getCityData()
    if (this.question.subtype === '多级下拉') {
      this.selectArr1 = this.question.answers.option.selectArr1
      this.selectValue1 = this.selectArr1.length > 0 ? this.selectArr1[0].value : ''

      var val = this.selectValue1
      this.selectArr2 = this.question.answers.option.selectArr2.filter(function(x) {
        return x.pid == val
      })
      this.selectValue2 = this.selectArr2.length > 0 ? this.selectArr2[0].value : ''

      val = this.selectValue2
      this.selectArr3 = this.question.answers.option.selectArr3.filter(function(x) {
        return x.pid == val
      })
      this.selectValue3 = this.selectArr3.length > 0 ? this.selectArr3[0].value : ''
    }
  },
  watch: {
    selectValue1: function(val) {
      this.selectArr2 = this.question.answers.option.selectArr2.filter(function(x) {
        return x.pid == val
      })
      this.selectValue2 = this.selectArr2.length > 0 ? this.selectArr2[0].value : ''
    },
    selectValue2: function(val) {
      this.selectArr3 = this.question.answers.option.selectArr3.filter(function(x) {
        return x.pid == val
      })
      this.selectValue3 = this.selectArr3.length > 0 ? this.selectArr3[0].value : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.q-content {
  display: flex;
  flex-direction: column;

  .ivu-select {
    width: 100%;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .address {
    width: 100%;
  }
}
</style>
